export const SET_YOUR_DEVICE = 'SET_YOUR_DEVICE';

export const setYourDevice = yourDevice => ({
  type: SET_YOUR_DEVICE,
  value: {yourDevice},
});
